export const GUIDE_TITLE = 'Le Guide Ultime des Restaurateurs';
export const GUIDE_PAGE_COUNT = 84;
export const renameGuide = (text) => String(text || '').replace(/\b(?:Le\s+)?Book Sabril\b/gi, GUIDE_TITLE);
export const openGuidePage = (page) => {
  if (Number.isInteger(Number(page)) && Number(page) >= 1 && Number(page) <= GUIDE_PAGE_COUNT) {
    window.dispatchEvent(new CustomEvent('sabril:open-guide', { detail: { page: Number(page) } }));
  }
};

// Work on Markdown text nodes, not HTML: keep emphasis, lists, and safe external links.
const citation = /\[?(?:Book Sabril|(?:Le\s+)?Guide Ultime des Restaurateurs)\s*[,·:—–-]?\s*(?:pp?\.?|pages?)\s*(\d{1,3}(?:\s*(?:et|,|\/|–|-|à)\s*(?:p\.?\s*)?\d{1,3})*)\]?/gi;
const pageNumbers = (text) => {
  const expanded = text.replace(/(\d+)\s*(?:–|-|à)\s*(?:p\.?\s*)?(\d+)/g, (all, start, end) => {
    const a = Number(start), b = Number(end);
    return a >= 1 && b <= GUIDE_PAGE_COUNT && a <= b ? Array.from({ length: b - a + 1 }, (_, i) => a + i).join(',') : all;
  });
  return [...new Set((expanded.match(/\d+/g) || []).map(Number))];
};

export function remarkGuideCitations() {
  return (tree) => {
    function visit(node) {
      if (!node.children || ['code', 'inlineCode'].includes(node.type)) return;
      if (node.type === 'link') {
        const text = node.children.map((child) => child.value || '').join('');
        const match = [...text.matchAll(citation)][0];
        if (match && pageNumbers(match[1]).length === 1) {
          const page = pageNumbers(match[1])[0];
          if (page >= 1 && page <= GUIDE_PAGE_COUNT) node.url = `#guide-page-${page}`;
        }
        node.children.forEach((child) => { if (child.type === 'text') child.value = renameGuide(child.value); });
        return;
      }
      node.children = node.children.flatMap((child) => {
        if (child.type !== 'text') { visit(child); return [child]; }
        const result = [];
        let cursor = 0;
        for (const match of child.value.matchAll(citation)) {
          const pages = pageNumbers(match[1]);
          if (!pages.every((page) => page >= 1 && page <= GUIDE_PAGE_COUNT)) continue;
          if (match.index > cursor) result.push({ type: 'text', value: renameGuide(child.value.slice(cursor, match.index)) });
          pages.forEach((page, index) => {
            if (index) result.push({ type: 'text', value: ' ' });
            const offset = (child.position?.start.offset || 0) + match.index + index;
            result.push({ type: 'link', url: `#guide-page-${page}`, position: { start: { line: 1, column: offset + 1, offset }, end: { line: 1, column: offset + 2, offset: offset + 1 } }, children: [{ type: 'text', value: `${GUIDE_TITLE} · p. ${page}` }] });
          });
          cursor = match.index + match[0].length;
        }
        if (cursor < child.value.length) result.push({ type: 'text', value: renameGuide(child.value.slice(cursor)) });
        return result;
      });
    }
    visit(tree);
  };
}